import { isEmptyObject } from '@teko/utils';
import { Consent, CookieConsent } from 'types';
import {
  COOKIE_CONSENT_COOKIE,
  nonRequiredCookieConsentMapping,
} from '../constants';
import { getCookieByName } from './env';
import { isServerless } from './index';

// Get cookie consent values from browser
export const getCookieConsentFromBrowserCookies = ():
  | CookieConsent
  | undefined => {
  const stringJSON = !!isServerless()
    ? getCookieByName(COOKIE_CONSENT_COOKIE)
    : '';
  if (!!stringJSON) {
    try {
      const parsed: CookieConsent = JSON.parse(stringJSON);
      if (parsed && Array.isArray(parsed.consents)) {
        return parsed;
      }
      return undefined;
    } catch (error) {
      return undefined;
    }
  }
  return undefined;
};

/**
 * @param consentName name of the consent, follow cookie consent types format (https://developers.google.com/tag-platform/security/concepts/consent-mode#consent-types)
 * @returns a boolean values indicates if the consent is approved by the user
 */
export const isConsentApproved = (
  consentName?: string,
  consents?: Consent[],
): boolean => {
  if (!isServerless()) return false;
  if (!consentName) return true;

  const cookieConsents = getCookieConsentFromBrowserCookies();
  if (isEmptyObject(cookieConsents)) return false;

  return (!!consents?.length ? consents : cookieConsents.consents).some(
    (consent) =>
      consent.isApproved &&
      consent?.policyValues?.find((val) => val === consentName),
  );
};

/**
 * Get consent name from cookie name, the consent name follows cookie consent types format (https://developers.google.com/tag-platform/security/concepts/consent-mode#consent-types)
 * @param cookieName cookie name
 * @returns the consent that the cookie belongs to
 */
export const getConsentNameFromNonRequiredCookie = (cookieName: string) => {
  return Object.keys(nonRequiredCookieConsentMapping).find((key) => {
    return nonRequiredCookieConsentMapping[
      key as keyof typeof nonRequiredCookieConsentMapping
    ].some((val) => val === cookieName);
  });
};
